import { Box } from '@mui/material';
import React, { useMemo } from 'react';
import { Edit, FiberManualRecord } from '@mui/icons-material';

export interface AccountStatisticFieldProps {
  value: string;
  label: string;
  graphLegendColor?: string;

  editable?: boolean;
  onClick?: () => void;
}

export const AccountStatisticField = (props: AccountStatisticFieldProps) => {
  const { label, value, editable, onClick, graphLegendColor } = props;

  const containerSx = useMemo(
    () => ({
      backgroundColor: 'background.paper',
      transition: 'background-color 200ms ease',
      padding: (theme: any) => theme.spacing(0, 1),
      cursor: editable ? 'pointer' : undefined,
      '&:hover': editable
        ? {
            backgroundColor: (theme: any) =>
              theme.palette.mode === 'dark'
                ? theme.palette.grey[700]
                : theme.palette.grey[200],
          }
        : undefined,
    }),
    [editable],
  );

  return (
    <Box sx={containerSx} onClick={onClick}>
      <Box sx={{ color: 'grey.500', fontSize: '0.8em' }}>{label}</Box>
      <Box sx={{ fontWeight: 600, fontSize: '1.6em' }}>
        {graphLegendColor ? (
          <FiberManualRecord htmlColor={graphLegendColor} />
        ) : null}
        {value} {editable ? <Edit color={'secondary'} /> : null}
      </Box>
    </Box>
  );
};
